<app-header></app-header>
<!-- breadcrumb section start -->
<section class="breadcrumb-section-main inner-2 breadcrumb-section-sm">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="breadcrumb-contain ">
          <div>
            <h2 class="breadcrumb-txt">All colours in "{{ sectorName }}"</h2>
          </div>
          <div>
            <ul>
              <li><a class="white" href="javascript:void()">Search Results</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
<!-- section start -->
<section class="section-b-space">
  <div class="collection-wrapper">
    <div class="container">
      <div class="row">
        <div class="collection-content col-sm-12">
          <div class="page-main-content">
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-12">
                  <div class="collection-product-wrapper">
                    <!-- Display Products -->
                    <div class="product-wrapper-grid" [class.list-view]="false" >
                      <div class="container-fluid">
                        <div class="row">
                          <span><h3>All colours in option "{{sectorName}}", click on an image to view the full product specifications</h3></span>
                          @for (product of productColours; track product) {
                            <div [class.col-xl-3]="true"
                              [class.col-md-6]="true"
                              class="col-grid-box"
                              >
                              <div class="product-box">
                                <div class="img-wrapper">
                                  <div class="front">
                                    <a [routerLink]="['/products/view', product.productSlug]">
                                      <img alt="" class="img-fluid img-product-results sectorimage"
                                        routerLinkActive="active" [src]="imageCheck(product.awsURL)">
                                    </a>
                                  </div>
                                </div>
                                <div class="product-detail">
                                  <a [routerLink]="['/products/view', product.slug]" class="notext">
                                    <h6 class="product-title">{{product.productName}} - {{product.name}}</h6>
                                  </a>
                                  @if (product.clearance === true;) {
                                    <span class="discon"> * Limited Stock * <br /></span>
                                  }
                                  <span>                                                                         {{product.briefDescription}} </span> <br />
                                </div>
                              </div>
                            </div>
                          }

                          <div class="col-sm-12 text-center section-b-space mt-5 no-found">
                            <h4>Want to go back to view as an overview??</h4>
                            <a [routerLink]="['/products/sector/', webSectorID]"  class="btn btn-default primary-btn ra-dius-0 m-t-10">
                            All colours of "{{sectorName}}"</a>
                          </div>

                        </div>
                      </div>




                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <!-- End Collection Sidebar -->
      </div><!-- end row -->
    </div>
  </div>
</section>
<!-- section End -->
<app-footer></app-footer>
